import Validators from "Common/Validators";
export default {
  socio_demographic_detail: {
    height: Validators.RemoveInitialSpace,
    weight: Validators.RemoveInitialSpace,
  },
  physical_health_complaints: {
    frequency: (str) => str.replace(/[-]/g, "").split("").join("-"),
  },
};
